import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import SessionStorageConst from "./blocks/consts/SessionStorageConst";
import Layout from "./components/core/Layout";
import Routes from "./components/core/Routes";
import PrometLoader from "./components/shared/PrometLoader";
import { ApplicationState } from "./store";
import { getIsFullProfileActivationInProgressActions } from "./store/account/actions";
import { getIsAuthenticatedActions } from "./store/auth/actions";

import * as CookieConsent from "vanilla-cookieconsent";
import CookieUtility from "./blocks/utils/cookie-utility/CookieUtility";
import { Language } from "./blocks/localization/Language";

type Props = typeof mapDispatchToProps;

const App = (props: Props) => {
  const isLoadingData = useSelector(
    (state: ApplicationState) => state.application.loadingData.isLoading,
  );
  const isFullProfileActivationInProgress = useSelector(
    (state: ApplicationState) =>
      state.account.account?.isFullProfileActivationInProgress,
  );

  const language = sessionStorage.getItem(
    SessionStorageConst.Language,
  ) as Language;

  useEffect(() => {
    if (sessionStorage.getItem(SessionStorageConst.IsAuthenticated)) {
      props.getIsAuthenticated();
    }

    CookieConsent.run({
      mode: "opt-in", // moraš prihvatit da bi koristio aplikaciju
      disablePageInteraction: true,
      cookie: CookieUtility.setupCookie(),
      categories: CookieUtility.getCategories(),
      language: CookieUtility.getLanguageOptions(language ?? "hr"),
      guiOptions: CookieUtility.getGuiOptions(),
    });
  }, []);

  useEffect(() => {
    let interval: any;

    if (isFullProfileActivationInProgress) {
      interval = setInterval(() => {
        props.getIsFullProfileActivationInProgress();
      }, 2000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isFullProfileActivationInProgress]);

  return (
    <PrometLoader isActive={isLoadingData}>
      <Layout>
        <Routes />
        <ToastContainer />
      </Layout>
    </PrometLoader>
  );
};

const mapDispatchToProps = {
  getIsAuthenticated: getIsAuthenticatedActions.request,
  getIsFullProfileActivationInProgress:
    getIsFullProfileActivationInProgressActions.request,
};

export default connect(null, mapDispatchToProps)(App as any);
